import { FlowManager } from '../../flow-management/FlowManager';
import { Step } from '../../views/Step';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';

const shouldShowUseCaseStep = state => {
  const IsOnbf016Variant = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ONBF016);
  return IsOnbf016Variant;
};

export const BranchUseCase = {
  name: 'BranchUseCase',
  stateCheck: shouldShowUseCaseStep,
  rebuildFlow: FlowManager.replaceStep(Step.HubInterest, Step.UseCase),
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};